import { User } from 'models/User';
import { OLDEST_NEWEST_COPY, SortingDirectionValues } from 'models/Sort';

export type BossModeAccoutnsTable = Pick<
  User,
  'firstName' | 'email' | 'phone' | 'createdAt' | 'promotedAt'
> &
  Record<'manage', any>;

export type BossModeAccoutnsTableKeys = Array<keyof BossModeAccoutnsTable>;

export const TABLE_COLUMNS: BossModeAccoutnsTableKeys = [
  'firstName',
  'email',
  'phone',
  'createdAt',
  'promotedAt',
  'manage',
];

type BossModeAccountsMap = Partial<
  Record<typeof TABLE_COLUMNS[number], string>
>;

export const HEADING_TRANSLATIONS: BossModeAccountsMap = {
  firstName: 'name',
  email: 'email',
  phone: 'phoneNumber',
  createdAt: 'joinedOn',
  promotedAt: 'promotedOn',
};

export const SORTING_VALUES: BossModeAccountsMap = {
  firstName: 'fullName',
  email: 'email',
  phone: 'contactNumber',
  createdAt: 'createdAt',
  promotedAt: 'promotedAt',
};

export const COLUMN_SIZE: Partial<
  Record<typeof TABLE_COLUMNS[number], number>
> = {
  manage: 50,
  email: 200,
  firstName: 200,
};

export const NAME_FILTER_KEY = 'name';
export const EMAIL_FILTER_KEY = 'email';
export const CREATED_AT_FILTER_KEY = 'createdTimeframe';
export const PROMOTED_AT_FILTER_KEY = 'promotedTimeframe';

export const MULTI_SORT_DIRECTION_COPY: Record<
  string,
  SortingDirectionValues[string]
> = {
  [SORTING_VALUES.createdAt]: OLDEST_NEWEST_COPY,
  [SORTING_VALUES.promotedAt]: OLDEST_NEWEST_COPY,
};

export const LOCKED_COLUMN: keyof BossModeAccoutnsTable = 'firstName';
